export async function getList({commit}, page) {
  const {errResponse, data: responseData} = await this.$adminRepositories.tags.index(page);
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return [];
}

export async function getListIgnoreOther({commit}, page) {
  const {errResponse, data: responseData} = await this.$adminRepositories.tags.getList(page);
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return [];
}

export async function deleteTagById({commit}, payload) {
  const response = await this.$adminRepositories.tags.delete(payload.id);
  await commit('removeItem', payload.index);
  return response;
}

export async function createTag({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.tags.create(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function updateTag({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.tags.update(payload.id, payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function findTagById({commit}, payload) {
  return await this.$adminRepositories.tags.show(payload);
}

export async function getListTagAdmin({commit}) {
  const {errResponse, data: responseData} = await await this.$adminRepositories.tags.getListByAdmin();
  if (!errResponse && responseData.success) {
    return responseData.data
  }
  
  return [];
}
